export default __webpack_public_path__ + "static/media/cito.34569544.png";